import { styled } from '@mui/material/styles';
export const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 490,
    margin: 'auto',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));
